import DOMPurify from 'dompurify';
const policy = {
  ALLOWED_TAGS: ['p','br','strong','b','em','i','u','s','del','blockquote','pre','code',
    'ul','ol','li','h1','h2','h3','h4','h5','h6','a','span','div','table','thead','tbody','tr','th','td'],
  ALLOWED_ATTR: ['href','title','class','colspan','rowspan'],
  ALLOW_DATA_ATTR: false, ALLOW_ARIA_ATTR: false,
  SANITIZE_NAMED_PROPS: true,
};
export function escapeHTML(value) {
  return String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
}
export function sanitizeHTML(input) {
  // Accept legacy actuality content {__html: string}, but never pass its object to React.
  const value = typeof input === 'string' ? input :
    (input && typeof input.__html === 'string' ? input.__html : '');
  if (!DOMPurify.isSupported) return '';
  const fragment = DOMPurify.sanitize(value.slice(0,100000), {...policy, RETURN_DOM_FRAGMENT:true});
  for (const node of fragment.querySelectorAll('[class]')) {
    const classes = node.className.split(/\s+/).filter(name => /^ql-(?:align-(?:center|right|justify)|indent-[1-8]|size-(?:small|large|huge)|font-(?:serif|monospace))$/.test(name));
    if (classes.length) node.setAttribute('class',classes.join(' ')); else node.removeAttribute('class');
  }
  for (const anchor of fragment.querySelectorAll('a')) {
    const href = anchor.getAttribute('href');
    if (href) {
      try {
        const url = new URL(href,'https://mesomb.invalid/');
        if (!['http:','https:'].includes(url.protocol) || href.startsWith('//')) anchor.removeAttribute('href');
      } catch { anchor.removeAttribute('href'); }
    }
    anchor.setAttribute('rel','noopener noreferrer');
  }
  const container = document.createElement('div');
  container.append(fragment);
  return container.innerHTML;
}
